import React from 'react'
import Page from 'component/page-container'
import { NavLink } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import cs from 'classnames'
import moment from 'moment'
import 'moment/locale/ru'
import './style.css'

/* global API */

const RecommendationListRoute = props => {

    const [recommendationList, setRecommendationList] = React.useState([])

    // const [userFilter, setUserFilter] = React.useState('')
    // const [tagFilter, setTagFilter] = React.useState('')

    React.useEffect(() => {
        API.instance().recommendation.getList().then(data => {
            console.log(data)
            setRecommendationList(data)
        })
    }, [])

    // const handleUserLink = userId => () => setUserFilter(userId)
    // const handleTagLink = tag => () => setTagFilter(tag)

    // const recommendationFilter = recommend => {
    //     const isTrueUser = !!userFilter && userFilter === recommend.userId
    //     const isTrueTag = !!tagFilter && recommend.tag.includes(tagFilter)
    //     return (
    //         (!userFilter && !tagFilter) ||
    //         (
    //             (!!userFilter && !tagFilter && isTrueUser && !isTrueTag) ||
    //             (!userFilter && !!tagFilter && !isTrueUser && isTrueTag) ||
    //             (!!userFilter && !!tagFilter && isTrueUser && isTrueTag)
    //         )
    //     )
    // }

    return (
        <Page className="recommendation-list-page" h1="Рекомендации">
            <div className="page__inner">
                <div className="container">
                    <p>Добавляем рекомендации в основном чатике с помощью <HashLink to="/bots#recommendation_club_bot">Хранителя Рекомендаций</HashLink>.</p>
                    <p><br /></p>
                </div>
                <table className="recommendation-list">
                    <thead>
                        <tr>
                            <td className="recommendation__title">Название</td>
                            <td className="recommendation__user">Рекомендует</td>
                            <td className="recommendation__category">Категория</td>
                            <td className="recommendation__date">Дата</td>
                            <td className="recommendation__likes"><i className="fa fa-heart" /></td>
                            <td className="recommendation__comments"><i className="fa fa-comment" /></td>
                        </tr>
                    </thead>
                    <tbody>
                        {recommendationList.map(recommendation =>
                            <tr
                                className={cs(
                                    "recommendation-list__recommendation",
                                    {"recommendation_liked": recommendation.isLiked},
                                    {"recommendation_visited": recommendation.isVisited}
                                )}
                                key={recommendation.id}
                            >
                                <td><NavLink to={"/recommendation/" + recommendation.id}>{recommendation.title}</NavLink></td>
                                <td>{recommendation.user.name} {recommendation.user.surname}</td>
                                <td>{recommendation.category.title}</td>
                                <td>{moment(recommendation.updatedAt).format('ll')}</td>
                                <td>{recommendation.likeCounter?recommendation.likeCounter:null}</td>
                                <td>{recommendation.commentCounter?recommendation.commentCounter:null}</td>
                            </tr>
                        )}
                    </tbody>
                </table>

                            {/* <div className="recommendation__user">
                                <span
                                    className="pseudo-link"
                                    onClick={handleUserLink(recommendation.user.id)}
                                >
                                    {recommendation.user.name} {recommendation.user.surname}
                                </span>
                            </div> */}
                {/* <div className="recommendation">
                    {!!tagFilter && (
                        <div className="test" onClick={handleTagLink('')}>
                            фильтрую по тегу {tagFilter}
                        </div>
                    )}
                </div>
                <div className="recommendation">
                    {!!userFilter && (
                        <div className="test">
                            {(() => {
                                const curUser = recommendations.find(i => i.userId === userFilter).user
                                return (
                                    <div className="test" onClick={handleUserLink('')}>
                                        фильтрую по {curUser.name} {curUser.surname}
                                    </div>
                                )
                            })()}
                        </div>
                    )}
                </div> */}
                {/* <div className="recommendation">
                    {recommendations.filter(recommendationFilter).map(recommendation => (
                        <div className="recommendation__item" key={recommendation.id}>
                            <div className="recommendation__user">
                                <span
                                    className="pseudo-link"
                                    onClick={handleUserLink(recommendation.user.id)}
                                >
                                    {recommendation.user.name} {recommendation.user.surname}
                                </span>
                            </div>
                            {!!recommendation.title.length && (
                                <div className="recommendation__title">
                                    {recommendation.title}
                                </div>
                            )}
                            <div
                                className="recommendation__description"
                                dangerouslySetInnerHTML={{ __html: nl2br(recommendation.description) }}
                            />
                            <div className="recommendation__link">
                                {recommendation.link.map(href => <a href={href} key={href}>{href}</a>)}
                            </div>
                            <div className="recommendation__tag">
                                {recommendation.tag.map(i => (
                                    <React.Fragment>
                                        <span className="pseudo-link" onClick={handleTagLink(i)}>#{i}</span>
                                        {' '}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    ))}
                </div> */}
            </div>
        </Page>
    )
}

export default RecommendationListRoute
